// extracted by mini-css-extract-plugin
module.exports = {"PageWrapper":"PageWrapper--1d8bS","Label":"Label--13ewI","Free":"Free--3c3vC"};